import { c as color, p as palette } from '../base/color-ec580bc4.js';
import { s as spacing, a as spacingValues } from '../base/spacing-b4d393ed.js';
import { f as focus } from '../base/focus-97063155.js';
import { g as globals } from '../base/globals-7fe5bdef.js';

const theme = {
  isEvolutionRebrand: true,
  color,
  focusVisible: focus,
  globals,
  palette,
  spacing,
  spacingValues
};
var evolutionTheme = theme;

export { evolutionTheme as e };
//# sourceMappingURL=evolution-53b6df54.js.map
